import {alpha, useTheme} from "@mui/material/styles";
import {Box, GlobalStyles, IconButton} from "@mui/material";
import {Colors} from "../../colors";
import {Icon, IconifyIcon} from "@iconify/react";
import {ColorSchema} from "../../color_models";
import {SnackbarKey, useSnackbar} from "notistack";
import React from "react";

const SnackbarStyles = () => {
  const theme = useTheme();
  const isLight = theme.palette.mode === "light";

  return (
    <GlobalStyles
      styles={{
        "#root": {
          "& .SnackbarContent-root": {
            width: "100%",
            padding: theme.spacing(1.5),
            margin: theme.spacing(0.25, 0),
            boxShadow: theme.customShadows.z8,
            borderRadius: theme.shape.borderRadius,
            color: isLight ? Colors.bw.white : Colors.grey._900,
            backgroundColor: isLight ? Colors.grey._1000 : Colors.bw.white,
            "&.SnackbarItem-variantSuccess, &.SnackbarItem-variantError, &.SnackbarItem-variantWarning, &.SnackbarItem-variantInfo":
              {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.background.paper,
              },
          },
          "& .SnackbarItem-message": {
            padding: "0 !important",
            fontWeight: theme.typography.fontWeightMedium,
          },
          "& .SnackbarItem-action": {
            marginRight: 0,
            color: theme.palette.action.active,
            "& svg": {width: 20, height: 20},
          },
        },
      }}
    />
  );
};

type SnackbarIconProps = {
  icon: IconifyIcon;
  color: ColorSchema;
};

const SnackbarIcon = ({icon, color}: SnackbarIconProps) => {
  return (
    <Box
      component="span"
      sx={{
        mr: 1.5,
        width: 40,
        height: 40,
        display: "flex",
        borderRadius: 1.5,
        alignItems: "center",
        justifyContent: "center",
        color: `${color}.main`,
        bgcolor: (theme) => alpha(theme.palette[color].main, 0.16),
      }}
    >
      <Icon icon={icon} width={24} height={24} />
    </Box>
  );
};

const CloseSnackbarButton = ({snackbarKey}: {snackbarKey: SnackbarKey}) => {
  const {closeSnackbar} = useSnackbar();
  return (
    <IconButton size="small" onClick={() => closeSnackbar(snackbarKey)}>
      <Icon icon="mdi:close" fontSize={20} />
    </IconButton>
  );
};

export {SnackbarStyles, SnackbarIcon, CloseSnackbarButton};
